import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'componentStatus',
		label: labels.status,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.evidenceComplete,
				data: [item.cTComplSend],
				color: dashboardChartColors.teal[3]
			},
			{
				name: utilLabels.evidencePending,
				data: [item.cTPartialSend],
				color: dashboardChartColors.teal[2]
			},
			{
				name: utilLabels.returned,
				data: [item.cTRetrn],
				color: dashboardChartColors.teal[1]
			},
			{
				name: utilLabels.groupAuditNotSent,
				data: [item.cTNotSent],
				color: dashboardChartColors.teal[0]
			}
		]
	});
